import { TimeOffsQuery } from "queries/TimeOffsQuery";
import { useCallback } from "react";
import { useQueryClient } from "react-query";
import { DayOffListQuery } from "views/dayoff/queries/DayOffListQuery";
import { MissingListQuery } from "views/dayoff/queries/MissingListQuery";

export const useTimeOffInvalidateQuery = () => {

    const queryClient = useQueryClient()

    return useCallback(() => {
        const obj = new DayOffListQuery()
        const objMissing = new MissingListQuery()
        const timeoffs = new TimeOffsQuery()
        queryClient.invalidateQueries(obj.queryKey)
        queryClient.invalidateQueries(objMissing.queryKey)
        queryClient.invalidateQueries(timeoffs.queryKey)
        queryClient.invalidateQueries("App.Harea.User.Absences.List")
    }, [queryClient])
};
